
export class HttpError {
    public scope: string = null;
    public code: number = null;
    public message: string = null;
    public metadata: string = null;
}
